<template>
  <div id="power-data" class="row-center" v-if="reFresh">
    <template >
      <div class="left column-center">
        <area-details
          width="180"
        ></area-details>
        <div class="list">
          <div class="search">
            <input
              type="text"
              v-model="filterText"
              placeholder="请输入关键字"
            />
            <img src="../../assets/img/search.png" alt="" />
          </div>
          <div class="tree" id="index-tree">
            <el-scrollbar style="height:100%">
              <el-tree
               :props="defaultProps"
                :expand-on-click-node="false"
                check-strictly
                check-on-click-node
                default-expand-all
                @check="currentChange"
                :show-checkbox="showCheckBox"
                node-key="id"
                @node-click="nodeClick"
                ref="tree"
                :data="treeData"
                :filter-node-method="filterNode"
                :default-checked-keys="defaultchecked"
              >
                <span
                  slot-scope="{ node, data }"
                  class="power-data-item"
                >
                  <span
                    :class="[
                      'power-data-item-label',
                      { checked: data.id === currentLoop.id },
                    ]"
                  >
                    <span slot="reference"> {{ data.name }}</span>
                  </span>
                </span>
              </el-tree>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <div class="data">
        <div v-if="treeData.length === 0" class="no-found-data-warpper">
          <img :src="require('../../assets/img/not_found_data.png')" alt="" />
        </div>
        <component
          v-else-if="currentLoop"
          :selectedLoops="checkedLoops"
          :currentLoop="currentLoop"
          :is="componentName"
        />
      </div>
    </template>
  </div>
</template>
<script>
import AreaDetails from "../../components/home/AreaDetails";
import PowerData from "./PowerData";
import PinnacleData from "./sheet/PinnacleData";
import Savingplan from "./sheet/Savingplan";
import reportDataBase from "./reportDataBase";
import {
  treeBuilding
} from "../../api/common";
export default {
  name: "PowerDataHome",
  components: {
    AreaDetails,
    PowerData,
    reportDataBase,
    PinnacleData,
    Savingplan
  },
  data() {
    return {
      selectedNodes: [],
      showAreaNumber: 0,
      reFresh: true,
      checkedLoops: [],
      currentLoop: null,
      filterText: "",
      loops: [],
      defaultchecked: [30,1,2],
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    };
  },

  computed: {
    tag() {
      return this.$route.params.tag;
    },
    routeName() {
      return this.$route.params.name;
    },
    showCheckBox() {
      return !(
        this.routeName === "Classification" 
        || this.routeName === "Suboption" 
        || this.routeName === "Pinnacle"
        || this.routeName === "Savingplan"
      );
    },
    componentName() {
      switch (this.$route.params.name) {
        case "Classification":
        case "Suboption": 
          return "PowerData";
        case "Pinnacle":
          return "PinnacleData";
        case "Savingplan":
          return "Savingplan";
        case "Extremum":
        case "Running":
        case "Suboption":
        case "Complex":
          return "reportDataBase";
      }
    },
    treeData() {
      let self = this
      switch (this.$route.params.name) {
        case "PowerData":
        case "Extremum":
        case "SubInverter":
        case "Running":
        case "Classification":
        case "Pinnacle":
        case "Savingplan":
        case "Suboption":
          if(this.loops.length>0){
            self.checkedLoops = [this.loops[0],this.loops[0].children[0],this.loops[0].children[1]]
            self.currentLoop = this.loops[0]
          }
          return self.loops
      }

      
    },
  },
  mounted() {
    this.GetreeBuilding();
    this.$nextTick(() => {
    　　this.$refs.tree.setCheckedKeys([30,1,2],true);//获取已经设置的资源后渲染
    });
  },
  methods: {
    //楼栋
    GetreeBuilding(){
      treeBuilding().then((res) => {
        this.loops = res.data.data.tree
      });
    },
    resetChecked() {
      this.checkedLoops = [];
      this.selectedNodes = [];
      this.$refs.tree.setCheckedKeys([]);
    },
    currentChange(data, node, n) {
      this.selectedNodes = node.checkedNodes;
      this.checkedLoops = this.selectedNodes.filter((l) => {
        return l ? l.name.indexOf(this.filterText) !== -1 : false;
      });
    },
    //点击传参
    //侧边栏子回路点击之后传参
    nodeClick(data) {
      this.$store.commit("ArcprotectStatus", data);
      this.currentLoop = data;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
  },
  watch: {
    tag(n, o) {
      this.checkedLoops = [];
      this.selectedNodes = [];
      // this.$refs.tree.setCheckedKeys([1,2],true);
    　　this.$refs.tree.setCheckedKeys([30,1,2],true);//获取已经设置的资源后渲染
    },
    routeName() {
      this.reFresh = false;
      this.$nextTick(() => {
        this.reFresh = true;
      });
      this.checkedLoops = [];
      this.selectedNodes = [];
      // this.$refs.tree.setCheckedKeys([1,2],true);
    　　this.$refs.tree.setCheckedKeys([30,1,2],true);//获取已经设置的资源后渲染
      this.filterText = "";
    },
    filterText(val) {
      this.$refs.tree.filter(val);
      this.checkedLoops = this.selectedNodes.filter((l) => {
        return l.loopName.indexOf(val) !== -1;
      });
    },
  },
};
</script>

<style scoped lang="less">
.clearsel {
  height: 45rem;
  line-height: 45rem;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  width: 100%;
  text-align: center;
  font-size: 18rem;
  cursor: pointer;
}
.area-list {
  position: absolute;
  left: 0;
  top: 0;
  .w(504);
  .h(520);
  background-color: #fff;
  box-shadow: 0 4rem 40px 0 rgba(0, 43, 102, 0.28);
  padding: 24rem 16rem;
  z-index: 999;

  .areas {
    margin-top: 24rem;
    // min-height: 200rem;
    .h(400);
    overflow: auto;
    .row {
      margin-bottom: 24rem;

      p {
        font-size: 16rem;
        color: #333333;
        font-weight: 400;
        .w(400);
      }

      img {
        .w(48);
        .h(48);
        margin-right: 13rem;
        margin-left: 8rem;
      }
    }
  }

  .search {
    .h(48);
    width: 100%;
    overflow: hidden;
    border-radius: 24rem;
    border: 1px solid rgba(0, 0, 0, 0.15);
    position: relative;

    input {
      width: 100%;
      height: 100%;
      padding: 0 20rem;
      font-size: 16rem;
      color: #000000;
      font-weight: 400;
      line-height: 48rem;
    }

    img {
      position: absolute;
      right: 16rem;
      top: 15rem;
      z-index: 99;
    }
  }
}

#power-data {
  justify-content: space-between;

  .h(968);

  > .data {
    position: relative;
    .w(1265);
    height: 100%;
  }

  .left {
    height: 100%;
    justify-content: flex-start !important;
    background-color: #fff;
    .w(325);

    .list {
      padding: 24rem 0rem 24rem 24rem;
      overflow: hidden;
      width: 100%;

      .search {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
      }

      input {
        border: none;
        outline: none;
        font-size: 18rem;
        color: #666666;
        .w(262);
      }

      .tree {
        margin-top: 35rem;

        height: 750 / 1080 * 100vh;
        overflow: auto;

        &::-webkit-scrollbar {
          width: 0 !important;
        }

        /deep/ .el-scrollbar__wrap {
          overflow-x: hidden;
          height: calc(100% - 10px);
        }

        .el-tree {
          padding-right: 24rem;
        }
      }
    }
  }
}

.power-data-item {
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;

  .power-data-item1 {
    position: absolute;
    right: 0;
  }

  .power-data-item-label {
    font-size: 18rem;
    font-weight: 400;
    color: #666666;
    width: 80%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    // white-space: nowrap;
  }

  .power-data-item-label.checked {
    font-weight: bold;
    color: #0d94ff;
  }

  .power-data-item-open {
    color: #68d86a;
    position: absolute;
    right: 0;
  }

  .power-data-item-close {
    position: absolute;
    right: 0;
    color: #fd4238;
  }
}

.no-found-data-warpper {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}

//弹出框样式
.area_popper {
  background-color: #3d4451 !important;
  border-radius: 6px !important;
  opacity: 0.9 !important;
  font-size: 12px !important;
  color: #ffffff !important;
  padding: 0 !important;
  transform: translateY(12px);
}

.showText {
  margin: 8px;
}

&::-webkit-scrollbar {
  width: 0 !important;
}

/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
  height: calc(100% - 10px);
}

.el-tree {
  padding-right: 33rem;
}
</style>
